import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=13b30ab0"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogAside: require('/opt/build/repo/components/blog/Aside.vue').default})
